module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./NomalWalletView.js"));
	}, "NomalWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NomalWalletView!./src/pages/Shop/Member/Wallet/NomalWallet/NomalWalletView.js
// module id = 1983
// module chunks = 367